<template>
	<div>
		<el-tabs v-model="activeName" @tab-click="handleClick" :class="'custom-tabs-' + activeName">
			<el-tab-pane label="限频设置" name="limitingSet">
				<div class="container">
					<div class="handle-box">
						<el-select size="small" @change="agentChange" v-if="isAdmin" v-model="query.agentId" filterable
							clearable placeholder="请选择代理商" class="handle-select"
							style="width: 260px;margin-right: 10px;">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" style="width: 260px;margin-right: 10px;" v-model="query.companyId"
							filterable clearable placeholder="企业" class="handle-select">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query.cardsId" clearable filterable placeholder="请选择品牌"
							style="margin-right: 10px;width: 180px;">
							<el-option v-for="item in cardTypeList" :key="item.label" :label="item.value"
								:value="item.label"></el-option>
						</el-select>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
							@click="getData">搜索</el-button>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" class="m_t_10"
							@click="handleAdd">添加设置</el-button>
					</div>
					<el-table :data="tableData" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
						:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
						<el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
						<el-table-column prop="companyName" label="企业" align="center"></el-table-column>
						<el-table-column prop="dxtAnswer" label="迪加日接通" align="center" width="120"></el-table-column>
						<el-table-column prop="dxtMonthAnswer" label="迪加月接通" align="center"
							width="120"></el-table-column>
						<el-table-column prop="companyLimit" label="限频次数" align="center">
							<template #default="scope">
								<div v-for="item in scope.row.companyLimit" :key="item"
									style="display: flex;flex-direction: row;">
									<span class="tag">{{item.cardName}}</span>
									<span class="tag" v-if="item.dxLimit">
										电信:{{item.dxLimit}}次</span>
									<span class="tag" v-if="item.ltLimit">联通:{{item.ltLimit}}次</span>
									<span class="tag" v-if="item.ydLimit">移动:{{item.ydLimit}}次</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" width="180">
							<template #default="scope">
								<el-button size="small" type="primary" :class="[theme]"
									@click="handleEdit(scope.row)">编辑</el-button>
								<el-button size="small" type="primary" :class="[theme]"
									@click="showRecord(scope.row)">记录</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="限频记录" name="limitingRecord">
				<div class="container">
					<div class="handle-box">
						<el-select size="small" @change="agentChange2" v-if="isAdmin" v-model="query2.agentId"
							filterable clearable placeholder="请选择代理商" class="handle-select"
							style="width: 260px;margin-right: 10px;">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" style="width: 260px;margin-right: 10px;" v-model="query2.companyId"
							filterable clearable placeholder="企业" class="handle-select">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-input size="small" v-model="query2.phone" clearable maxlength="12" placeholder="请输入号码"
							style="width: 180px;" class="handle-input mr10"></el-input>
						<el-select size="small" v-model="query2.cardsId" clearable filterable placeholder="请选择品牌"
							style="margin-right: 10px;width: 180px;">
							<el-option v-for="item in cardTypeList" :key="item.label" :label="item.value"
								:value="item.label"></el-option>
						</el-select>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
							@click="getData2">搜索</el-button>

					</div>
					<el-table :data="tableData2" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
						:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
						<el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
						<el-table-column prop="companyName" label="企业" align="center"></el-table-column>
						<el-table-column prop="cardName" label="品牌" align="center" width="100"></el-table-column>
						<el-table-column prop="standard" label="制式" align="center" width="100"></el-table-column>
						<el-table-column prop="phone" label="限频号码" align="center"></el-table-column>
						<el-table-column prop="limit" label="限频次数" align="center" width="160"></el-table-column>
						<el-table-column prop="createdAt" label="创建时间" align="center"></el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query2.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query2.pageSize" :total="pageTotal2" @size-change="handleSizeChange2"
							@current-change="handlePageChange2"></el-pagination>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>

		<el-dialog title="添加" v-model="addVisible" width="850px" @close="closeDialog">
			<el-form label-width="80px" :model="addForm" ref="editForm">
				<el-form-item label="代理" prop="agentId" v-if='isAdmin'>
					<el-select size="small" v-model="addForm.agentId" filterable @change="agentChange3" clearable
						:disabled="companyDis" placeholder="代理商" class="handle-select mr10" style="width: 100%;">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="企业" prop="companyId">
					<el-select size="small" v-model="addForm.companyId" filterable @change="companyChange"
						placeholder="请选择企业" style="width: 100%;">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="品牌" prop="cardsId" v-for="item in addForm.companyLimit" :key="item.label">
					<el-select size="small" v-model="item.cardsId" clearable filterable placeholder="请选择品牌"
						style="width: 100px;margin-right: 10px;">
						<el-option v-for="items in cardTypeList" :key="items.label" :label="items.value"
							:value="items.label"></el-option>
					</el-select>
					<span style="margin-right: 6px;">电信</span>
					<el-input size="small" style="width: 140px;margin-right: 10px;" v-model.trim="item.dxLimit"
						placeholder="请输入限频次数"></el-input>
					<span style="margin-right: 6px;">联通</span>
					<el-input size="small" style="width: 140px;margin-right: 10px;" v-model.trim="item.ltLimit"
						placeholder="请输入限频次数"></el-input>
					<span style="margin-right: 6px;">移动</span>
					<el-input size="small" style="width: 140px;margin-right: 10px;" v-model.trim="item.ydLimit"
						placeholder="请输入限频次数"></el-input>
					<el-button type="primary" icon="el-icon-plus" size="small" @click.prevent="addDomain()" />
					<el-button type="danger" icon="el-icon-minus" size="small" @click.prevent="removeDomain(item)" />
				</el-form-item>
				<el-form-item label="迪加日接通" prop="dxtAnswer">
					<el-input size="small" placeholder="请输入迪加日接通次数 (-1 或大于 -1 的整数)" v-model="addForm.dxtAnswer"
						@input="handleInput" @blur="handleBlur" :class="{'error': hasError}">
					</el-input>

				</el-form-item>
				<el-form-item label="迪加月接通" prop="dxtMonthAnswer">
					<el-input size="small" placeholder="请输入迪加月接通次数 (-1 或大于 -1 的整数)" v-model="addForm.dxtMonthAnswer"
						@input="handleInput2" @blur="handleBlur2" :class="{'error': hasError2}">
					</el-input>
				</el-form-item>
				<el-form-item class="dis-end" v-if="!addForm.companyLimit?.length">
					<el-button type="primary" icon="el-icon-plus" size="small" @click.prevent="addDomain()" />
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getCompanyLimitAdd">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="编辑" v-model="editVisible" width="850px" @close="closeDialog">
			<el-form label-width="80px" :model="editForm" ref="editForm">
				<el-form-item label="代理" prop="agentId" v-if='isAdmin'>
					<el-input size="small" style="width: 100%;" v-model="editForm.agentName" disabled></el-input>
				</el-form-item>
				<el-form-item label="企业" prop="companyId">
					<el-input size="small" style="width: 100%;" v-model="editForm.companyName" disabled
						placeholder=""></el-input>
				</el-form-item>
				<el-form-item label="品牌" prop="cardsId" v-for="item in editForm.companyLimit" :key="item.label">
					<el-select size="small" v-model="item.cardsId" clearable filterable placeholder="请选择品牌"
						style="width: 100px;margin-right: 10px;">
						<el-option v-for="items in cardTypeList" :key="items.label" :label="items.value"
							:value="items.label"></el-option>
					</el-select>
					<span style="margin-right: 6px;">电信</span>
					<el-input size="small" style="width: 140px;margin-right: 10px;" v-model.trim="item.dxLimit"
						placeholder="请输入限频次数"></el-input>
					<span style="margin-right: 6px;">联通</span>
					<el-input size="small" style="width: 140px;margin-right: 10px;" v-model.trim="item.ltLimit"
						placeholder="请输入限频次数"></el-input>
					<span style="margin-right: 6px;">移动</span>
					<el-input size="small" style="width: 140px;margin-right: 10px;" v-model.trim="item.ydLimit"
						placeholder="请输入限频次数"></el-input>
					<el-button type="primary" icon="el-icon-plus" size="small" @click.prevent="addDomain2()" />
					<el-button type="danger" icon="el-icon-minus" size="small" @click.prevent="removeDomain2(item)" />
				</el-form-item>

				<el-form-item label="迪加日接通" prop="dxtAnswer">
					<el-input size="small" placeholder="请输入迪加日接通次数 (-1代表不限制 正数代表接通次数)" v-model="editForm.dxtAnswer"
						@input="handleInput3" @blur="handleBlur3" :class="{'error': hasError3}">
					</el-input>

				</el-form-item>
				<el-form-item label="迪加月接通" prop="dxtMonthAnswer">
					<el-input size="small" placeholder="请输入迪加月接通次数 (-1代表不限制 正数代表接通次数)" v-model="editForm.dxtMonthAnswer"
						@input="handleInput4" @blur="handleBlur4" :class="{'error': hasError4}">
					</el-input>
				</el-form-item>
				<el-form-item class="dis-end" v-if="!editForm.companyLimit?.length">
					<el-button type="primary" icon="el-icon-plus" size="small" @click.prevent="addDomain2()" />
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getCompanyLimitAdd2">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="限频记录" v-model="recordVisible" width="850px" @close="closeDialog">
			<el-table :data="recordTableData" border class="table" ref="multipleTable" v-loading="loading"
				header-cell-class-name="table-header" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe>
				<el-table-column prop="user" label="操作者" align="center" width="140"></el-table-column>
				<el-table-column prop="companyLimit" label="限频次数" align="center">
					<template #default="scope">
						<div v-for="item in scope.row.companyLimit" :key="item"
							style="display: flex;flex-direction: row;">
							<span class="tag">{{item.cardName}}</span>
							<span class="tag" v-if="item.dxLimit">
								电信:{{item.dxLimit}}次</span>
							<span class="tag" v-if="item.ltLimit">联通:{{item.ltLimit}}次</span>
							<span class="tag" v-if="item.ydLimit">移动:{{item.ydLimit}}次</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="time" label="操作时间" align="center" width="155"></el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getCompanyLimit,
		companyLimitAdd,
		getCompanyLimitRecord
	} from '../../api/dijia.js';
	import {
		getCardType
	} from '../../api/cardType.js';
	import {
		fetchAgent
	} from '../../api/agentIndex';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies,
	} from '../../api/companyIndex';
	export default {
		name: 'DJfreeze',
		data() {
			return {
				activeName: 'limitingSet',
				loading: false,
				theme: localStorage.getItem('theme'),
				theme8: localStorage.getItem('theme8'),
				theme3: localStorage.getItem('theme3'),
				query: {
					agentId: '',
					companyId: '',
					cardsId: '',
					pageIndex: 1,
					pageSize: 10
				},
				tableData: [],
				agents: [],
				companys: [],
				pageTotal: 0,
				addVisible: false,
				addForm: {
					companyId: "",
					companyLimit: [{
						cardsId: "",
						dxLimit: "",
						ltLimit: "",
						ydLimit: "",
					}],
					dxtAnswer: '',
					dxtMonthAnswer: '',
				},
				errorMessage4: '',
				errorMessage3: '',
				errorMessage2: '',
				errorMessage: '',
				hasError4: false,
				hasError3: false,
				hasError2: false,
				hasError: false,
				cardTypeList: [],
				isAdmin: false,
				isAgent: false,
				multipleSelection: [],
				editForm: {
					dxtAnswer: '',
					dxtMonthAnswer: ''
				},
				editVisible: false,


				query2: {
					agentId: '',
					companyId: '',
					cardsId: '',
					phone: '',
					pageIndex: 1,
					pageSize: 10
				},
				tableData2: [],
				pageTotal2: 0,

				recordVisible: false,
				recordTableData: [],
			};
		},
		created() {
			let role = localStorage.getItem('ms_role');
			if (role === 'admin') {
				this.isAdmin = true;
				this.isAgent = true;
			}
			if (role === 'subAgent') {
				this.isAgent = true;
			}
			this.getCardType();
			this.init();
			this.updateTabStyle();
			this.updatePaginationStyle();

		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.number:hover {
				        color: ${this.theme8} !important;
				    }
					.active:hover {
					    color: #fff !important;
					}
					.more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			updateTabStyle() {
				// 动态更新样式
				let styleEl = document.getElementById('dynamic-tab-style');
				if (!styleEl) {
					styleEl = document.createElement('style');
					styleEl.id = 'dynamic-tab-style';
					document.head.appendChild(styleEl);
				}

				styleEl.innerHTML = `
			        .el-tabs__active-bar {
			            background-color: ${this.theme8} !important;
			        }
			        .el-tabs__item.is-active {
			            color: ${this.theme8} !important;
			        }
			        .el-tabs__item:hover {
			            color: ${this.theme8} !important;
			            opacity: 0.8;
			        }
			    `;
			},
			handleClick(tab, event) {
				this.activeName = tab.props.name;
				if (tab.props.name == 'limitingSet') {
					this.getData();
				} else if (tab.props.name == 'limitingRecord') {
					this.getData2();
				}
			},
			//获取品牌
			getCardType() {
				getCardType('').then(res => {
					this.cardTypeList = res.data;
				})
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			agentChange2(agentId) {
				this.query2.agentId = agentId;
				this.query2.companyId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			agentChange3(agentId) {
				this.addForm.agentId = agentId;
				this.addForm.companyId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			getData() {
				this.loading = true;
				getCompanyLimit(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getData2() {
				this.loading = true;
				getCompanyLimitRecord(this.query2).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData2 = res.data.list;
						this.pageTotal2 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			addDomain() {
				this.addForm.companyLimit.push({
					cardsId: "",
					dxLimit: "",
					ltLimit: "",
					ydLimit: "",
				});
			},
			removeDomain(item) {
				var index = this.addForm.companyLimit.indexOf(item)
				if (index !== -1) {
					this.addForm.companyLimit.splice(index, 1)
				}
			},
			addDomain2() {
				this.editForm.companyLimit.push({
					cardsId: "",
					dxLimit: "",
					ltLimit: "",
					ydLimit: "",
				});
			},
			removeDomain2(item) {
				var index = this.editForm.companyLimit.indexOf(item)
				if (index !== -1) {
					this.editForm.companyLimit.splice(index, 1)
				}
			},

			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			handleAdd() {
				this.addForm.agentId = '';
				this.addForm.companyId = '';
				this.addForm.companyLimit = [{
					cardsId: "",
					dxLimit: "",
					ltLimit: "",
					ydLimit: "",
				}];
				this.addForm.cardsId = '';
				this.addVisible = true;
			},
			handleEdit(row) {
				this.editForm = row;
				this.editVisible = true;
			},
			getCompanyLimitAdd() {
				this.addForm.type = 1;
				this.addForm.dxtAnswer = parseInt(this.addForm.dxtAnswer);
				this.addForm.dxtMonthAnswer = parseInt(this.addForm.dxtMonthAnswer);
				companyLimitAdd(JSON.stringify(this.addForm)).then(res => {
					if (res?.code === 200) {
						this.addVisible = false;
						this.$message.success(res.data);
						setTimeout(() => {
							this.getData();
						}, 1000);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getCompanyLimitAdd2() {
				this.editForm.type = 2;
				this.editForm.dxtAnswer = parseInt(this.editForm.dxtAnswer);
				this.editForm.dxtMonthAnswer = parseInt(this.editForm.dxtMonthAnswer);
				companyLimitAdd(JSON.stringify(this.editForm)).then(res => {
					if (res?.code === 200) {
						this.editVisible = false;
						this.$message.success(res.data);
						setTimeout(() => {
							this.getData();
						}, 1000);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeDialog() {
				this.addVisible = false;
				this.editVisible = false;
				this.recordVisible = false;
			},

			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getData();
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},

			handleSizeChange2(val) {
				this.query2.pageSize = val;
				this.query2.pageIndex = 1; // 重置到第一页
				this.getData2();
			},
			// 分页导航
			handlePageChange2(val) {
				this.query2.pageIndex = val;
				this.getData2();
			},
			showRecord(row) {
				this.recordVisible = true;
				this.recordTableData = row.log;
			},
			handleInput(value) {
				// 允许空值
				if (value === '') {
					this.hasError = false;
					return;
				}

				// 检查是否只包含数字和可选的负号
				if (!/^-?\d*$/.test(value)) {
					// 如果不是纯数字，过滤掉非数字字符
					this.addForm.dxtAnswer = value.replace(/[^-0-9]/g, '');
					return;
				}

				// 检查是否满足条件
				this.validateInput(value);
			},

			handleBlur() {
				// 失去焦点时进行最终验证
				if (this.addForm.dxtAnswer === '') {
					return;
				}

				this.validateInput(this.addForm.dxtAnswer);

				// 如果验证失败，清空输入
				if (this.hasError) {
					this.addForm.dxtAnswer = '';
				}
			},

			validateInput(value) {
				const numValue = parseInt(value, 10);
				if (isNaN(numValue) || !Number.isInteger(numValue)) {
					this.hasError = true;
					this.errorMessage = '请输入有效的整数';
					return;
				}
				if (numValue < -1) {
					this.hasError = true;
					this.errorMessage = '只能输入 -1 或大于 -1 的整数';
					return;
				}
				this.hasError = false;
				this.errorMessage = '';
			},


			handleInput2(value) {
				if (value === '') {
					this.hasError2 = false;
					return;
				}
				if (!/^-?\d*$/.test(value)) {
					this.addForm.dxtMonthAnswer = value.replace(/[^-0-9]/g, '');
					return;
				}
				this.validateInput2(value);
			},

			handleBlur2() {
				if (this.addForm.dxtMonthAnswer === '') {
					return;
				}
				this.validateInput2(this.addForm.dxtMonthAnswer);
				if (this.hasError2) {
					this.addForm.dxtMonthAnswer = '';
				}
			},

			validateInput2(value) {
				const numValue = parseInt(value, 10);
				if (isNaN(numValue) || !Number.isInteger(numValue)) {
					this.hasError2 = true;
					this.errorMessage2 = '请输入有效的整数';
					return;
				}
				if (numValue < -1) {
					this.hasError2 = true;
					this.errorMessage2 = '只能输入 -1 或大于 -1 的整数';
					return;
				}
				this.hasError2 = false;
				this.errorMessage2 = '';
			},



			handleInput3(value) {
				if (value === '') {
					this.hasError3 = false;
					return;
				}
				if (!/^-?\d*$/.test(value)) {
					this.editForm.dxtMonthAnswer = value.replace(/[^-0-9]/g, '');
					return;
				}
				this.validateInput3(value);
			},

			handleBlur3() {
				if (this.editForm.dxtMonthAnswer === '') {
					return;
				}
				this.validateInput3(this.editForm.dxtMonthAnswer);
				if (this.hasError3) {
					this.editForm.dxtMonthAnswer = '';
				}
			},

			validateInput3(value) {
				const numValue = parseInt(value, 10);
				if (isNaN(numValue) || !Number.isInteger(numValue)) {
					this.hasError3 = true;
					this.errorMessage3 = '请输入有效的整数';
					return;
				}
				if (numValue < -1) {
					this.hasError3 = true;
					this.errorMessage3 = '只能输入 -1 或大于 -1 的整数';
					return;
				}
				this.hasError3 = false;
				this.errorMessage3 = '';
			},





			handleInput4(value) {
				if (value === '') {
					this.hasError4 = false;
					return;
				}
				if (!/^-?\d*$/.test(value)) {
					this.editForm.dxtMonthAnswer = value.replace(/[^-0-9]/g, '');
					return;
				}
				this.validateInput4(value);
			},

			handleBlur4() {
				if (this.editForm.dxtMonthAnswer === '') {
					return;
				}
				this.validateInput4(this.editForm.dxtMonthAnswer);
				if (this.hasError4) {
					this.editForm.dxtMonthAnswer = '';
				}
			},

			validateInput4(value) {
				const numValue = parseInt(value, 10);
				if (isNaN(numValue) || !Number.isInteger(numValue)) {
					this.hasError4 = true;
					this.errorMessage4 = '请输入有效的整数';
					return;
				}
				if (numValue < -1) {
					this.hasError4 = true;
					this.errorMessage4 = '只能输入 -1 或大于 -1 的整数';
					return;
				}
				this.hasError4 = false;
				this.errorMessage4 = '';
			},
		}
	};
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 240px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.tag {
		background-color: #ecf5ff;
		border-color: #d9ecff;
		height: 32px;
		padding: 0 10px;
		line-height: 30px;
		font-size: 12px;
		color: #409EFF;
		border-width: 1px;
		border-style: solid;
		border-radius: 4px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		white-space: nowrap;
		margin: 6px;
	}
</style>